import { ROUTES as e } from "@editor/ui-utils";
import { getChannelListComponent as t } from "@modules/channel-editor-ui-components";
//#endregion
//#region src/index.ts
var n = {
	messages: {
		en: {
			channels: {
				plural: "Channels",
				basics: "Basics",
				backButton: "Back",
				createChannel: "Create channel",
				editChannel: "Edit channel",
				secondaryChannels: "Secondary channels",
				settingsLabel: "Link box configuration",
				config: "Stage configuration",
				messageNotSelf: "The parent channel cannot be this channel.",
				messageMandatoryInfo: "This channel cannot be saved because mandatory information is missing.",
				messageMandatoryInfoConfig: "This channel cannot be saved as mandatory information is missing in the channel configuration.",
				messageCreated: "Channel created",
				messageUpdated: "Channel updated",
				messageDeleted: "Channel deleted",
				name: "Channel title",
				parentChannel: "Parent channel",
				seoTitle: "SEO headline",
				seoDescription: "SEO description",
				adTags: "Ad tags",
				markAsAd: "Mark as ad",
				adsEnabled: "Activate ads",
				defaultConfig: "Use standard channel configuration",
				goToChannel: "To channel",
				articles: "Number of articles",
				galleries: "Number of galleries",
				videoPages: "Amount of video pages",
				contentItems: "Number of contents",
				excludedChannels: "Excluded channels",
				errorMandatoryFields: "This channel cannot be saved because mandatory information is missing.",
				checkWhiteSpace: "A space at the beginning is not allowed.",
				noEditTooltip: "This channel is originally from the {source} editor.",
				errorFailedLoadChannel: "Error loading channel",
				handledInLegacySystem: "A change to the link box settings will affect possible sub-channels.",
				useParentChannelSettings: "Use link box settings of parent channel",
				channelChangeConfirmationDialog: "Are you sure that you want to save these settings? The changes will directly impact the affected article and channel pages.",
				migration: "Migration",
				path: "Path",
				pathConflictNotice: {
					template: "This path is in conflict with {pathType} path of another channel. Only {pathRoutable} channel will be reachable!",
					pathTypeCurrent: "the current",
					pathTypeOld: "an old",
					pathRoutableThis: "this",
					pathRoutableOther: "the other"
				},
				slug: "Slug",
				noIndex: "Activate noIndex",
				noFollow: "Activate noFollow",
				excludeFromNewsSitemap: "Exclude from news sitemap",
				slugChangeConfirmationTitle: "Are you sure you want to change the URL slug?",
				slugChangeConfirmationMessage: "Warning: Changing the URL slug will affect all related article URLs and may invalidate existing links, which can impact search engine rankings and usability. Please speak to the SEO team or the relevant stakeholders beforehand to ensure that the change is sensible and necessary.",
				messageExistingArticles: "The channel cannot be deleted due to published articles.",
				deleteChannelMessage: "Are you sure you want to delete this channel? This will also delete all subchannels and take all articles offline!",
				deleteChannel: "Delete channel",
				markAsSpecial: "Mark as special",
				specialConfirmModal: {
					yes: "Yes",
					cancel: "Cancel",
					title: "Transform to regular channel",
					message: "Are you sure you want to transform this special into a regular channel? This will remove all data related to specials."
				},
				backgroundColor: "Background color",
				defaultColor: "Default color",
				specialColors: {
					default: "Default",
					aqua: "Aqua",
					black: "Black",
					blue: "Blue",
					red: "Red",
					gray: "Gray",
					brand: "Brand",
					transparent: "Transparent"
				},
				specialImageSelectorLabel: "Select or upload logo (optional)",
				logoLinkUrl: "Logo link URL",
				description: "Channel description",
				errorFailedOperation: "Error performing the latest operation",
				addSelectedChannels: "Add selected channels",
				addSelectedTags: "Add selected tags",
				addSelectedTagsWithCount: "Add ({count}) selected tags",
				channelTagsMissingInfo: "The stage tags cannot be saved because mandatory information is missing.",
				addLink: "Add link",
				pagination: "Pagination",
				adBlockProtectionEnabled: "Screen13 Adblock Retargeting"
			},
			channelsList: {
				all: "All",
				title: "Channel",
				newButton: "New channel",
				search: "Search for channel name",
				searchByBrand: "Search for brand",
				brand: "Brand",
				loading: "Loading channels",
				headerTitle: "Title",
				headerBreadcrumb: "Breadcrumb",
				edit: "Edit",
				view: "Show",
				mainChannel: "Search for main channel",
				childChannel: "Search for subchannel",
				hideNoIndexChannels: "Hide noIndex channels",
				tooltip: "Teasers and links can be freely defined here to link other elements instead of articles. Promotional offers should be marked with the label \"Advertisement\"."
			},
			channelConfigApi: {
				created: "Channel configuration created",
				outdated: "Channel configuration is outdated. Update failed",
				updated: "Channel configuration updated ",
				notFound: "Channel configuration not found"
			},
			channelConfig: { title: "Channel title" },
			channelSettings: {
				linkBoxList: "Link box list: placement {placementName}",
				addLinkBox: "Add link box",
				active: "Active",
				deactivateOnChannelPages: "Deactivate on channel pages",
				deactivateOnChannelPagesHelp: "Linkbox is shown on article pages only",
				changeLinkBoxSettingsWarn: "Changing the link box settings will affect subchannels.",
				placementATooltip: "Placement above Outbrain or after 15 teasers",
				placementBTooltip: "Placement integrated in upper part of Outbrain widget or after 20 teasers",
				placementCTooltip: "Placement integrated in lower part of Outbrain widget or after 25 teasers",
				placementDTooltip: "Placement below Outbrain or after last teaser",
				articleVideoStageLabel: "Most viewed video",
				articleVideoStageEnable: "Enable video stage on articles",
				articleVideoStageChannel: "Video subchannel",
				articleVideoStageChannelTooltip: "Select a direct subchannel of the video channel. The most-viewed video pages of the last 7 days will be shown on article pages.",
				enableHeadlinesPage: "Enable headlines page",
				excludeHeadlinesSubchannels: "Exclude subchannels for headlines page",
				checkParentSettingsModal: "When the “Use parent channel's link box settings” checkbox is checked, link box placements will be overwritten when changes are made to the parent channel’s link boxes. Are you sure you want to continue?",
				uncheckParentSettingsModal: "When the checkbox \"Use parent channel's link box settings\" is disabled, link boxes placements will no longer be updated by changes made to parent channel. Are you sure you want to continue?",
				parentSettingsTooltip: "Use parent channel's link box settings",
				changeParentSettingsModal: "Link box placements will be overwritten by changes made to the link boxes in the parent channel. Are you sure you want to continue?",
				paginationEnabled: "Activate pagination",
				pageLimit: "Page limit",
				teasersPerPage: "Teasers per page",
				startOffset: "Start offset with item number:",
				paginationButtonName: "Navigation layout (first page of the channel)",
				pageNavigationButton: "Numerical navigation",
				moreArticleButton: "Button \"More articles\"",
				articleTypes: "Article types",
				sourceChannels: "Sources (Channels)",
				includeSubchannels: "Include subchannels",
				includeSecondaryChannels: "Include secondary channels",
				articleStageLayout: "Article stage layout",
				articleStageLayoutDefault: "Default",
				promoBannerTitle: "Channel Promo Banner",
				promoBannerMobileImage: "Mobile image",
				promoBannerDesktopImage: "Desktop image",
				promoBannerUrl: "URL",
				promoBannerNofollow: "Nofollow",
				promoBannerNewTab: "Open in new tab",
				tagCloudTitle: "Cloud with short titles - A501: Placement A",
				tagCloudTooltip: "Placement at the end of the article content",
				tagCloudLimit: "Maximum items",
				entityType: "Page type",
				paginationEntity: {
					articles: "Articles",
					videoPages: "Video pages"
				}
			},
			channelBlock: {
				messageNoNewBlocks: "New blocks cannot be added here anymore.",
				addContent: "Add stage",
				sourceChannels: "Source channels",
				includeSubchannels: "Include subchannels",
				stageTitle: "Stage title",
				hideStageTitle: "Hide stage title",
				stageTitleUrl: "Stage title URL",
				stageLinkedChannel: "Channel link for stage title",
				placements: "Placements",
				applyToAllPlacements: "Apply to all placements",
				applyToAllPlacementsDialogTitle: "Are you sure you want to apply the settings to all placements?",
				applyToAllPlacementsDialogMessage: "All existing placement settings will be lost.",
				autoArticlePlacement: "Newest articles",
				autoGalleryPlacement: "Newest galleries",
				fixedArticlePlacement: "Fixed article",
				fixedGalleryPlacement: "Fixed gallery",
				autoVideoPagePlacement: "Auto video page",
				fixedVideoPagePlacement: "Fixed video page",
				performanceVideoPagePlacement: "Video page by performance (PV)",
				linkoutVideoPagePlacement: "Linkout video page",
				linkoutPlacement: "Linkout",
				listItemArticlePlacement: "List",
				performanceArticlePlacement: "Article by performance (PV)",
				apiTeaserPlacement: "API",
				includeSecondaryChannels: "Include secondary channel",
				includeNoIndex: "Include noIndex",
				excludeRepublished: "Exclude republished articles",
				excludeFromDeduplication: "Exclude from deduplication",
				includeGalleries: "Include galleries",
				articlesTypeFilter: "Only articles of type",
				performanceTimespanDays: "For placements \"By performance\": Timespan",
				performanceDays7: "7 days",
				performanceDays30: "30 days",
				stageLinkText: "Stage link text",
				stageLinkUrl: "Stage link URL",
				profileLinkUrlDisabledHint: "The linked channel takes precedence over the link URL",
				profileJobDescription: "Job description (optional override)",
				profileAuthorsCount: "Number of authors",
				profileRemoveAuthor: "Remove this author row"
			},
			channel: { blocks: {
				channelArticleBlock: "Article stage",
				channelGalleryBlock: "Gallery stage",
				channelVideoBlock: "Video stage",
				channelImageBlock: "Image",
				channelInPageWidgetBlock: "Inpage widget",
				channelCwcWidgetBlock: "CWC widget",
				channelMixedBlock: "Mixed stage",
				channelTextField: "Text field",
				channelNavigationBlock: "Navigation stage",
				channelProfileBlock: "Profile Stage",
				channel: "Channel",
				premiumOnly: "Inside only",
				excludedContent: "Excluded content",
				excludedChannels: "Excluded channels",
				excludedWeights: "Excluded weights",
				stageLayout: "Stage layout",
				a101Layout: "Single column with lead text - A101",
				a102Layout: "Two column with lead text - A102",
				a113Layout: "Three columns without lead text - A113",
				a113a401Highlighted: "Set stage as highlighted",
				a201Layout: "Single column headlines - A201",
				a202Layout: "Headlines single column, collapsible - A202",
				a202DefaultCollapsed: "Collapsed",
				a203Layout: "Three column headlines - A203",
				a301Layout: "Slider without color - A301",
				a302Layout: "Slider with color - A302",
				a401Layout: "Combo main top with color - A401",
				a402Layout: "Combo main left - A402",
				a501Layout: "Cloud with short titles - A501",
				a601Layout: "One column with lead text and 1:1 image - A601",
				g101Layout: "Gallery three columns - G101",
				v104Layout: "One column with teaser, image left - V104",
				v301Layout: "Slider without color - V301",
				m101Layout: "Single column kicker and headline - M101",
				p101Layout: "Profile-Stage round - P101",
				i101Layout: "Image single column - I101",
				t101Layout: "Text single column - T101",
				w101Layout: "Inpage widget - W101",
				w102Layout: "Sport-Heute widget - W102",
				low: "Low",
				medium: "Medium",
				high: "High",
				showExceptions: "Show exceptions",
				hideExceptions: "Hide exceptions",
				messageNotEmptyFixed: "A fixed article cannot be empty.",
				selectArticle: "Select article",
				list: "List",
				singleGallery: "Single gallery",
				dayGallery: "Gallery of the day",
				title: "Title",
				kicker: "Kicker",
				link: "Link",
				label: "Label",
				leadText: "Lead text",
				selectImage: "Select or upload image",
				subChannelTags: "Subchannel tags",
				listSize: "Size of article list",
				excludedSubchannels: "Excluded subchannels",
				showPreview: "Show preview",
				hidePreview: "Hide preview",
				newstickerText: "The newsticker always shows the latest articles.",
				loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
				channelTags: "Channel tags (max. 5)",
				stageTags: "Stage tags (ideally five)",
				openInCurrentWindow: "Open in current window",
				teaserTextStandard: "Two to six teasers. One main teaser, the rest below",
				teaserStandard: "Standard",
				teaserTextTwoCol: "Exactly five teasers. One main teaser, the rest below in two columns",
				teaserTwoCol: "Two columns",
				markAsAd: "Mark as ad",
				bInside: "Bunte Inside",
				duplicatePlacements: "Duplicate placement settings",
				duplicatePlacementsMsg: "The placements are already filled.",
				duplicatePlacementsMsg2: "Delete a placement to duplicate the placement settings.",
				messageDuplicateContent: "Duplicate content within the channel configuration",
				messageNotFiveArticles: "There must be exactly five articles in the two column layout.",
				messageMinimumArticleCount: "There must be at least two articles in a channel.",
				topbarText: "Articles with the highest priority are selected in Pilot > Home & Top Bar and displayed in the \"Meistgelesen\" stage.",
				performanceOffset: "Performance offset in hours",
				messageVideoCount: "Video blocks must contain three or six videos.",
				messageUniqueContent: "Duplicate content within this block",
				messageValidateOffset: "Performance offset needs to be a value between 0 and 10.",
				mainStageText: "Newest articles with high priority are selected in Pilot > Home & Top Bar and displayed on the main stage.",
				personlookText: "This is the person look. It is filled externally by tracdelight.",
				channelSportHeuteWidgetBlock: "Sport-Heute widget"
			} },
			channelsMigration: {
				directEditNotice: "Warning: The settings visible here take effect immediately and are independent of the save function.",
				source: "Source",
				legacyId: "Legacy ID",
				renderedByCtf: "Rendered by CTF",
				editableInCtf: "Editable in Vibe",
				modifiedInCtf: "Modified in Vibe",
				confirmModal: {
					yes: "Yes",
					cancel: "Cancel",
					renderedBy: {
						title: "Change rendering to CTF",
						message: "Are you sure you want to change the rendering system?"
					},
					editableIn: {
						title: "Editable in Vibe",
						message: "Are you sure you want to make the channel editable in CTF? This cannot be undone!"
					}
				},
				viewCtfVersion: "View CTF version"
			},
			navigation: {
				selectLayout: "Select layout",
				n101Layout: "Tag cloud - N101",
				n102Layout: "Tag cloud with icons - N102",
				n201Layout: "Icons round - N201",
				n202Layout: "Icons rectangular - N202",
				n301Layout: "Title with icons, three columns - N301",
				navigationByUrl: "By URL",
				navigationByChannel: "By channel",
				linkedChannels: "Linked channels",
				highlightChannels: "Highlight Channels",
				amountOfIcons: "Number of icons ({min}-{max})",
				amountOfElements: "Number of links ({min}-{max})",
				toggleLinkLabel: "Expand/collapse button text",
				toggleLinkLabelPrefix: "All / Less",
				firstColumn: "Activate first column with icons",
				firstColumnTitle: "First column title",
				item: "Item",
				itemTitle: "Title",
				itemChannel: "Linked channel",
				itemNavigationType: "Navigation type",
				itemUrl: "URL",
				itemUrlHint: "Internal (/path) or external (https://...)",
				itemUrlApp: "URL for App",
				itemUrlAppHint: "Internal (/path) or external (https://...) or deep-link",
				itemIcon: "Icon (First letter if empty)",
				icons: {
					chip: {
						bestdeals: "Price tag",
						car: "Car",
						community: "Persons (two)",
						download: "Download",
						energy: "Lightning bolt",
						entertainment: "Console",
						food: "Cutlery",
						home: "House",
						laptop: "Laptop",
						mobile: "Mobile",
						social: "Speech bubble",
						tv: "Remote control",
						wlan: "WLAN",
						thumbsup: "Thumbs up",
						newspage: "Newspaper",
						marktcheck: "Medal",
						check: "Checkbox",
						lightbulb: "Lightbulb",
						notification: "Bell",
						settings: "Gear wheel",
						pencil: "Pencil",
						browser: "Tabs",
						document: "Document",
						fitness: "Fitness",
						business: "Business"
					},
					focus: {
						gruppen: "Group",
						live: "Red dot",
						news: "Document",
						spielplan: "Calendar",
						tippspiel: "Dice",
						video: "Play button"
					}
				}
			}
		},
		de: {
			channels: {
				plural: "Channels",
				basics: "Basics",
				backButton: "Zurück",
				settingsLabel: "Linkbox-Konfiguration",
				createChannel: "Channel erstellen",
				editChannel: "Channel bearbeiten",
				secondaryChannels: "Sekundäre Channels",
				config: "Stage-Konfiguration",
				messageNotSelf: "Der übergeordnete Channel kann nicht dieser Channel sein.",
				messageMandatoryInfo: "Der Channel kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				messageMandatoryInfoConfig: "Der Channel kann nicht gespeichert werden, weil in der Channel-Konfiguration Pflichtinformationen fehlen.",
				messageCreated: "Channel erstellt",
				messageUpdated: "Channel aktualisiert",
				messageDeleted: "Channel gelöscht",
				name: "Channel-Titel",
				parentChannel: "Übergeordneter Channel",
				seoTitle: "SEO-Überschrift",
				seoDescription: "SEO-Beschreibung",
				adTags: "Werbe-Tags",
				markAsAd: "Als Anzeige markieren",
				adsEnabled: "Werbung aktivieren",
				defaultConfig: "Standard-Channel-Konfiguration nutzen",
				goToChannel: "Zum Channel",
				errorMandatoryFields: "Der Channel kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				articles: "Artikel-Anzahl",
				galleries: "Anzahl der Galerien",
				videoPages: "Anzahl der Videoseiten",
				contentItems: "Anzahl der Inhalte",
				excludedChannels: "Ausgeschlossene Channels",
				checkWhiteSpace: "Ein Leerzeichen am Anfang ist nicht erlaubt.",
				noEditTooltip: "Dieser Channel stammt ursprünglich vom {source}-Editor.",
				errorFailedLoadChannel: "Fehler beim Laden des Channels",
				handledInLegacySystem: "Eine Änderung der Linkbox-Einstellungen wirkt sich auf mögliche Sub-Channels aus.",
				useParentChannelSettings: "Linkbox-Einstellungen des übergeordneten Channels verwenden",
				channelChangeConfirmationDialog: "Willst du diese Einstellungen wirklich speichern? Die Änderungen werden direkt auf den betroffenen Artikel- und Channel-Seiten sichtbar.",
				migration: "Migration",
				path: "Pfad",
				pathConflictNotice: {
					template: "Dieser Pfad überschneidet sich mit {pathType} Pfad eines anderen Channels. Nur {pathRoutable} Channel ist erreichbar!",
					pathTypeCurrent: "dem aktuellen",
					pathTypeOld: "einem alten",
					pathRoutableThis: "dieser",
					pathRoutableOther: "der andere"
				},
				slug: "URL-Slug",
				noIndex: "NoIndex aktivieren",
				noFollow: "NoFollow aktivieren",
				excludeFromNewsSitemap: "Aus der News-Sitemap ausschließen",
				slugChangeConfirmationTitle: "Willst du den URL-Slug wirklich ändern?",
				slugChangeConfirmationMessage: "Achtung: Das Ändern des URL-Slugs wirkt sich auf alle zugehörigen Artikel-URLs aus und kann bestehende Links ungültig machen, was das Suchmaschinen-Ranking und die Benutzerfreundlichkeit beeinträchtigen kann. Bitte vorher mit dem SEO-Team oder den zuständigen Personen absprechen, um sicherzustellen, dass die Änderung sinnvoll und notwendig ist.",
				messageExistingArticles: "Channel kann aufgrund von veröffentlichten Artikeln nicht gelöscht werden.",
				deleteChannelMessage: "Soll dieser Channel wirklich gelöscht werden? Alle Sub-Channel werden ebenfalls gelöscht und alle Artikel dadurch offline genommen.",
				deleteChannel: "Channel löschen",
				markAsSpecial: "Als Special kennzeichnen",
				specialConfirmModal: {
					yes: "Ja",
					cancel: "Abbrechen",
					title: "In regulären Channel umwandeln",
					message: "Willst du dieses Special wirklich in einen regulären Channel umwandeln? Damit gehen alle Special-Daten verloren."
				},
				backgroundColor: "Hintergrundfarbe",
				defaultColor: "Standard-Farbe",
				specialColors: {
					default: "Standard",
					aqua: "Aqua",
					black: "Schwarz",
					blue: "Blau",
					red: "Rot",
					gray: "Grau",
					brand: "Marke",
					transparent: "Transparent"
				},
				specialImageSelectorLabel: "Logo auswählen oder hochladen (optional) ",
				logoLinkUrl: "URL für Logo-Verlinkung",
				description: "Channel-Beschreibung",
				errorFailedOperation: "Fehler beim Ausführen der letzen Aktion",
				addSelectedChannels: "Ausgewählte Channels hinzufügen",
				addSelectedTags: "Ausgewählte Tags hinzufügen",
				addSelectedTagsWithCount: "Ausgewählte ({count}) Tags hinzufügen",
				channelTagsMissingInfo: "Die Stage-Tags können nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				addLink: "Link hinzufügen",
				pagination: "Paginierung",
				adBlockProtectionEnabled: "Screen13 Adblock Retargeting"
			},
			channelsList: {
				all: "Alle",
				title: "Channel",
				newButton: "Neuer Channel",
				search: "Suchen nach Channel-Titel",
				searchByBrand: "Suchen nach Marke",
				brand: "Marke",
				loading: "Channels werden geladen",
				headerTitle: "Titel",
				headerBreadcrumb: "Breadcrumb/Pfad",
				edit: "Bearbeiten",
				view: "Anzeigen",
				mainChannel: "Suchen nach Haupt-Channel",
				childChannel: "Suchen nach Sub-Channel",
				hideNoIndexChannels: "NoIndex-Channels ausblenden",
				tooltip: "Hier können Teaser und Links frei definiert werden, um andere Elemente statt Artikel zu verlinken. Werbliche Angebote sollten mit dem Label \"Anzeige\" gekennzeichnet werden."
			},
			channelConfigApi: {
				created: "Channel-Konfiguration erstellt",
				outdated: "Channel-Konfiguration veraltet. Aktualisierung fehlgeschlagen",
				updated: "Channel-Konfiguration aktualisiert",
				notFound: "Channel-Konfiguration nicht gefunden"
			},
			channelConfig: { title: "Channel-Titel" },
			channelSettings: {
				linkBoxList: "Linkbox-Liste: Platzierung {placementName}",
				addLinkBox: "Linkbox hinzufügen",
				active: "Aktiv",
				deactivateOnChannelPages: "Auf Channel-Seiten deaktivieren",
				deactivateOnChannelPagesHelp: "Linkbox wird nur auf Artikelseiten angezeigt",
				changeLinkBoxSettingsWarn: "Eine Änderung der Linkbox-Einstellungen wirkt sich auf die Sub-Channel aus.",
				placementATooltip: "Platzierung über Outbrain bzw. nach 15 Teasern",
				placementBTooltip: "Platzierung oben integriert in Outbrain-Widget bzw. nach 20 Teasern",
				placementCTooltip: "Platzierung  unten integriert in Outbrain-Widget bzw. nach 25 Teasern",
				placementDTooltip: "Platzierung unter Outbrain bzw. nach dem letzten Teaser",
				articleVideoStageLabel: "Meistgesehene Videos",
				articleVideoStageEnable: "Video-Stage auf Artikeln aktivieren",
				articleVideoStageChannel: "Video-Subchannel",
				articleVideoStageChannelTooltip: "Wähle einen direkten Subchannel des Video-Channels. Die meistgesehenen Videoseiten der letzten 7 Tage werden auf Artikelseiten angezeigt.",
				enableHeadlinesPage: "Schlagzeilen-Seite aktivieren",
				excludeHeadlinesSubchannels: "Sub-Channels für die Schlagzeilen-Seite ausschließen",
				checkParentSettingsModal: "Wenn die Checkbox \"Linkbox-Einstellungen des übergeordneten Channels verwenden\" aktiviert wird, werden bei Änderungen an den Linkboxen dort die Platzierungen hier überschrieben. Willst du wirklich fortfahren?",
				uncheckParentSettingsModal: "Wird der Haken der Checkbox \"Linkbox-Einstellungen des übergeordneten Channel verwenden\" entfernt, werden die Änderungen an den Linkbox-Platzierungen des übergeordneten Channel nicht mehr übernommen. Willst du wirklich fortfahren?",
				parentSettingsTooltip: "Linkbox-Einstellungen des übergeordneten Channels verwenden",
				changeParentSettingsModal: "Die Linkbox-Platzierungen werden durch Änderungen an Linkboxen im übergeordneten Channel überschrieben. Willst du wirklich fortfahren?",
				paginationEnabled: "Paginierung aktivieren",
				pageLimit: "Seiten-Limit",
				teasersPerPage: "Teasers pro Seite",
				startOffset: "Offset mit folgender Artikelnummer beginnen:",
				paginationButtonName: "Navigations-Layout (erste Seite des Channels)",
				pageNavigationButton: "Numerische Navigation",
				moreArticleButton: "Button \"Mehr Artikel\"",
				articleTypes: "Artikel-Typen",
				sourceChannels: "Quellen (Channels)",
				includeSubchannels: "Subchannels einschließen",
				includeSecondaryChannels: "Sekundäre Channels einschließen",
				articleStageLayout: "Artikel-Stage-Layout",
				articleStageLayoutDefault: "Standard",
				promoBannerTitle: "Kanal-Promo-Banner",
				promoBannerMobileImage: "Bild Mobil",
				promoBannerDesktopImage: "Bild Desktop",
				promoBannerUrl: "URL",
				promoBannerNofollow: "Nofollow",
				promoBannerNewTab: "In neuem Tab öffnen",
				tagCloudTitle: "Cloud mit Kurztiteln - A501: Placement A",
				tagCloudTooltip: "Platzierung am Ende des Artikel-Contents",
				tagCloudLimit: "Maximale Anzahl",
				entityType: "Seitentyp",
				paginationEntity: {
					articles: "Artikel",
					videoPages: "Videoseiten"
				}
			},
			channelBlock: {
				messageNoNewBlocks: "Es können keine neuen Blöcke mehr hinzugefügt werden.",
				addContent: "Stage hinzufügen",
				sourceChannels: "Channel als Quellen",
				includeSubchannels: "Sub-Channels einschließen",
				stageTitle: "Stage-Titel",
				hideStageTitle: "Stage-Titel ausblenden",
				stageTitleUrl: "URL für Stage-Titel",
				stageLinkedChannel: "Channel-Link für Stage-Titel",
				placements: "Platzierungen",
				applyToAllPlacements: "Auf alle Platzierungen übertragen",
				applyToAllPlacementsDialogTitle: "Möchtest du die Einstellungen wirklich auf alle Platzierungen übertragen?",
				applyToAllPlacementsDialogMessage: "Alle bestehenden Platzierungseinstellungen gehen verloren.",
				autoArticlePlacement: "Neueste Artikel",
				autoGalleryPlacement: "Neueste Galerien",
				fixedArticlePlacement: "Fester Artikel",
				fixedGalleryPlacement: "Feste Galerie",
				autoVideoPagePlacement: "Automatische Videoseite",
				fixedVideoPagePlacement: "Feste Videoseite",
				performanceVideoPagePlacement: "Videoseite nach Performance (PV)",
				linkoutVideoPagePlacement: "Freier Teaser Videoseite",
				linkoutPlacement: "Freier Teaser",
				listItemArticlePlacement: "Artikel aus Liste",
				performanceArticlePlacement: "Artikel nach Performance (PV)",
				apiTeaserPlacement: "API",
				includeSecondaryChannels: "Sekundäre Channels einschließen",
				includeNoIndex: "NoIndex einschließen",
				excludeRepublished: "Erneut veröffentlichte Artikel ausschließen",
				excludeFromDeduplication: "Von Deduplizierung ausschließen",
				includeGalleries: "Galerien einschließen",
				articlesTypeFilter: "Nur Artikel vom Typ",
				performanceTimespanDays: "Für Platzierungen \"nach Performance\": Zeitraum",
				performanceDays7: "7 Tage",
				performanceDays30: "30 Tage",
				stageLinkText: "Linktext für Stage",
				stageLinkUrl: "Link-URL für Stage",
				profileLinkUrlDisabledHint: "Der Channel-Link hat Vorrang vor der Link-URL",
				profileJobDescription: "Jobbezeichnung (optionale Übersteuerung)",
				profileAuthorsCount: "Anzahl der Autor:innen",
				profileRemoveAuthor: "Diese Autor:in-Zeile entfernen"
			},
			channel: { blocks: {
				channelArticleBlock: "Artikel-Stage",
				channelGalleryBlock: "Galerie-Stage",
				channelVideoBlock: "Video-Stage",
				channelImageBlock: "Bild",
				channelInPageWidgetBlock: "Inpage-Widget",
				channelCwcWidgetBlock: "CWC-Widget",
				channelMixedBlock: "Gemischte Stage",
				channelTextField: "Textfeld",
				channelNavigationBlock: "Navigation-Stage",
				channelProfileBlock: "Profil-Stage",
				channel: "Channel",
				premiumOnly: "Nur Premiumartikel",
				excludedContent: "Ausgeschlossener Inhalt",
				excludedChannels: "Ausgeschlossene Channels",
				excludedWeights: "Ausgeschlossene Gewichtung",
				channelTags: "Channel-Tags (max. 5)",
				stageTags: "Stage-Tags (am besten fünf)",
				openInCurrentWindow: "Im aktuellen Fenster öffnen",
				stageLayout: "Stage-Layout",
				a101Layout: "Einspalter mit Vorspann - A101",
				a102Layout: "Zweispalter mit Vorspann - A102",
				a113Layout: "Dreispalter ohne Vorspann - A113",
				a113a401Highlighted: "Stage als “Highlight” setzen",
				a201Layout: "Einspalter Headlines - A201",
				a202Layout: "Headlines einspaltig, einklappbar - A202",
				a202DefaultCollapsed: "Eingeklappt",
				a203Layout: "Dreispalter Headlines - A203",
				a301Layout: "Slider ohne Farbe - A301",
				a302Layout: "Slider mit Farbe - A302",
				a401Layout: "Kombo Hauptbild oben mit Farbe - A401",
				a402Layout: "Kombo Hauptbild links - A402",
				a501Layout: "Cloud mit Kurztiteln - A501",
				a601Layout: "Einspalter mit Vorspann und 1:1-Bild - A601",
				g101Layout: "Galerie dreispaltig - G101",
				v104Layout: "Einspalter mit Vorspann, Bild links - V104",
				v301Layout: "Slider ohne Farbe - V301",
				m101Layout: "Einspalter Vorzeile und Hauptzeile - M101",
				p101Layout: "Profil-Stage rund - P101",
				i101Layout: "Bild einspaltig -I101",
				t101Layout: "Text einspaltig- T101",
				w101Layout: "Inpage-Widget - W101",
				w102Layout: "Sport-Heute-Widget - W102",
				low: "Niedrig",
				medium: "Mittel",
				high: "Hoch",
				showExceptions: "Ausnahmen anzeigen",
				hideExceptions: "Ausnahmen ausblenden",
				messageNotEmptyFixed: "Ein fester Artikel kann nicht leer sein.",
				selectArticle: "Artikel auswählen",
				list: "Liste",
				singleGallery: "Einzelne Galerie",
				dayGallery: "Galerie des Tages",
				title: "Titel",
				kicker: "Vorzeile",
				link: "Link",
				label: "Label",
				leadText: "Vorspann",
				selectImage: "Bild auswählen oder hochladen",
				subChannelTags: "Sub-Channel-Tags",
				listSize: "Umfang der Artikel-Liste",
				excludedSubchannels: "Ausgeschlossene Sub-Channels",
				showPreview: "Vorschau anzeigen",
				hidePreview: "Vorschau ausblenden",
				newstickerText: "Der Newsticker zeigt immer die zuletzt veröffentlichten Artikel an.",
				loginwallText: "Nutzer können sich hier registrieren, um mehr Inhalte zu sehen. Eingeloggten Benutzern wird dieses Element nicht angezeigt.",
				teaserTextStandard: "Zwei bis sechs Teaser. Ein Hauptteaser, der Rest darunter",
				teaserStandard: "Standard",
				teaserTextTwoCol: "Genau fünf Teaser. Ein Hauptteaser, der Rest darunter in zwei Spalten",
				teaserTwoCol: "Zwei Spalten",
				markAsAd: "Als Anzeige markieren",
				bInside: "Bunte Inside",
				duplicatePlacements: "Platzierungseinstellungen duplizieren",
				duplicatePlacementsMsg: "Die Platzierungen sind schon vollständig gefüllt.",
				duplicatePlacementsMsg2: "Platzierung löschen, um die Platzierungseinstellungen zu duplizieren.",
				messageDuplicateContent: "Duplicate Content in der Channel-Konfiguration",
				messageNotFiveArticles: "Es müssen genau fünf Artikel im Zweispalten-Layout sein.",
				messageMinimumArticleCount: "Es müssen mindestens zwei Artikel in einem Channel sein.",
				topbarText: "Artikel mit der höchsten Priorität werden in Pilot > Home & Top Bar ausgewählt und in der \"Meistgelesen\"-Stage angezeigt.",
				performanceOffset: "Performanceversatz in Stunden",
				messageVideoCount: "Video-Stages müssen drei oder sechs Videos enthalten.",
				messageUniqueContent: "Duplicate Content in diesem Block",
				messageValidateOffset: "Performanceversatz muss ein Wert zwischen 0 und 10 sein.",
				mainStageText: "Neuste Artikel mit hoher Priorität werden in Pilot > Home & Top Bar ausgewählt und in der Mainstage angezeigt.",
				personlookText: "Hier wird der Starlook plaziert. Der Inhalt wird von tracdelight befüllt.",
				channelSportHeuteWidgetBlock: "Sport-Heute-Widget"
			} },
			channelsMigration: {
				directEditNotice: "Achtung: Die hier sichtbaren Einstellungen werden sofort wirksam und sind unabhängig vom Speichern.",
				source: "Ursprungs-CMS",
				legacyId: "Legacy-ID",
				renderedByCtf: "Gerendert von CTF",
				editableInCtf: "Bearbeitbar in Vibe",
				modifiedInCtf: "Geändert in Vibe",
				confirmModal: {
					yes: "Ja",
					cancel: "Abbrechen",
					renderedBy: {
						title: "Rendering durch CTF",
						message: "Willst du das Rendering-System wirklich ändern?"
					},
					editableIn: {
						title: "Bearbeitbar in Vibe",
						message: "Willst du die Bearbeitung dieses Channels wirklich in Vibe erlauben? Das lässt sich nicht rückgängig machen."
					}
				},
				viewCtfVersion: "CTF-Version ansehen"
			},
			navigation: {
				selectLayout: "Stage-Layout",
				n101Layout: "Tag-Cloud - N101",
				n102Layout: "Tag-Cloud mit Icons - N102",
				n201Layout: "Icons rund - N201",
				n202Layout: "Icons rechteckig - N202",
				n301Layout: "Titel mit Icons, dreispaltig - N301",
				navigationByUrl: "Nach URL",
				navigationByChannel: "Nach Channel",
				linkedChannels: "Verlinkte Channels",
				highlightChannels: "Highlight-Channels",
				amountOfIcons: "Anzahl der Icons ({min}-{max})",
				amountOfElements: "Anzahl der Links ({min}-{max})",
				toggleLinkLabel: "Text für Ein-/Ausklapp-Schaltfläche",
				toggleLinkLabelPrefix: "Alle / Weniger",
				firstColumn: "Erste Spalte mit Icons aktivieren",
				firstColumnTitle: "Titel der ersten Spalte",
				itemIcon: "Icon (Erster Buchstabe, falls leer)",
				item: "Element",
				itemTitle: "Titel",
				itemChannel: "Verlinkter Channel",
				itemNavigationType: "Navigationstyp",
				itemUrl: "URL",
				itemUrlHint: "Intern (/pfad) oder extern (https://...)",
				itemUrlApp: "URL für die App",
				itemUrlAppHint: "Intern (/pfad) oder extern (https://...) oder Deep-Link",
				icons: {
					chip: {
						bestdeals: "Preisschild",
						car: "Auto",
						community: "Personen (zwei)",
						download: "Download",
						energy: "Blitz",
						entertainment: "Konsole",
						food: "Besteck",
						home: "Haus",
						laptop: "Laptop",
						mobile: "Handy",
						social: "Sprechblase",
						tv: "Fernbedienung",
						wlan: "WLAN",
						thumbsup: "Daumen hoch",
						newspage: "Zeitung",
						marktcheck: "Medaille",
						check: "Checkbox",
						lightbulb: "Glühbirne",
						notification: "Glocke",
						settings: "Zahnrad",
						pencil: "Stift",
						browser: "Registerkarten",
						document: "Dokument",
						fitness: "Fitness",
						business: "Business"
					},
					focus: {
						gruppen: "Gruppe",
						live: "Roter Punkt",
						news: "Dokument",
						spielplan: "Kalender",
						tippspiel: "Würfel",
						video: "Play-Button"
					}
				}
			}
		}
	},
	routes: [{
		path: `/${e.channels.path}`,
		meta: { i18RouteTitleKey: e.channels.path },
		children: [
			{
				path: "",
				name: "channel_list",
				component: t,
				props: (e) => e.query,
				meta: { requiredRight: "channels:navigate" }
			},
			{
				path: "new",
				name: "channel_new",
				component: () => import("./channel-edit-BiYlZHOW.js"),
				meta: { requiredRight: "channels:navigate" }
			},
			{
				path: ":id",
				name: "channel_detail",
				component: () => import("./channel-edit-BiYlZHOW.js"),
				props: (e) => ({
					id: e.params.id,
					backRoute: "/channels",
					tab: e.query.tab
				}),
				meta: { requiredRight: "channels:navigate" }
			}
		]
	}]
};
//#endregion
export { n as channelModule };

//# sourceMappingURL=index.es.js.map